import axios from 'axios';
import _ from 'lodash';
import shortId from 'shortid';
import { reportError } from './error-handling-service';

export function getTemporarySignedUrl(key) {
  const endpoint = `${process.env.REACT_APP_CHECK_FILE_EXISTS_API}/${key}`;
  const payload = {};
  const headers = {};

  return axios.get(endpoint, payload, headers)
    .then(response => response.data.body.signedUrl)
    .catch(error => {
      reportError('GET_TEMPORARY_SIGNED_URL_ERROR', error);
    });
}

export function getUploadUrl(file, s3Key) {
  const endpoint = process.env.REACT_APP_CREATE_UPLOAD_URL_API;
  const payload = {
    data: {
      filepath: s3Key,
      contentType: file.type ? file.type : 'text/plain',
    },
  };
  const headers = {};

  return axios.post(endpoint, payload, headers);
}

export function uploadToS3(acceptedFiles) {
  const PROCESSED_IDENTIFIER = 'processed';

  const onFileUploaded = key => {
    const fullKey = `${PROCESSED_IDENTIFIER}-${key}`;

    return fullKey;
  };

  const uploadFile = file => new Promise(resolve => {
    const FILE_UPLOAD_PREFIX = `dz-${shortId.generate()}`;
    const S3_PROCESSING_TIMEOUT = 3000;
    const key = `${FILE_UPLOAD_PREFIX}-${_.replace(file.name, /(?:[^\w?.]+_*|_+)+/g, '_')}`;

    getUploadUrl(file, key)
      .then(response => _.get(response, 'data.body.url', null))
      .then(url => {
        const options = {
          headers: {
            'Content-Type': file.type ? file.type : 'text/plain',
          },
        };

        return axios.put(url, file, options);
      })
      .then(() => {
        setTimeout(() =>
          resolve(onFileUploaded(key)),
        S3_PROCESSING_TIMEOUT);
      },
      );
  });

  return Promise.all(_.map(acceptedFiles, uploadFile));
}



/** WEBPACK FOOTER **
 ** ./src/utils/s3-service.js
 **/